(function () {
  class CardSlider {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('.cardSlider__track');
      if (!this.track) return;

      this.cards = Array.from(this.track.querySelectorAll('.cardSlider__card'));
      this.prevBtns = el.querySelectorAll('.cardSlider__navBtn--prev');
      this.nextBtns = el.querySelectorAll('.cardSlider__navBtn--next');
      this.expandedCard = null;

      this._bindEvents();
      this._updateButtons();
    }

    _bindEvents() {
      this.cards.forEach(card => {
        const expandBtn = card.querySelector('[data-action="expand"]');
        const collapseBtn = card.querySelector('[data-action="collapse"]');
        if (expandBtn) expandBtn.addEventListener('click', () => this._expand(card));
        if (collapseBtn) collapseBtn.addEventListener('click', () => this._collapse());
      });

      this.prevBtns.forEach(btn => btn.addEventListener('click', () => this._scroll(-1)));
      this.nextBtns.forEach(btn => btn.addEventListener('click', () => this._scroll(1)));

      // Manuelles Sliden (Swipe / Trackpad / Mausrad) klappt offene Karte zu
      this.track.addEventListener('touchmove', () => this._collapse(false), { passive: true });
      this.track.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) this._collapse(false);
      }, { passive: true });

      this.track.addEventListener('scroll', () => {
        clearTimeout(this._scrollTimer);
        this._scrollTimer = setTimeout(() => this._updateButtons(), 100);
      }, { passive: true });
    }

    _snapOffset() {
      return parseFloat(getComputedStyle(this.track).scrollPaddingInlineStart) || 0;
    }

    _maxScroll() {
      return this.track.scrollWidth - this.track.clientWidth;
    }

    // Snap-Positionen = linke Kante jeder Karte relativ zum Track,
    // ausgerichtet auf scroll-padding-inline-start
    _snapPositions() {
      const offset = this._snapOffset();
      const max = this._maxScroll();
      const positions = this.cards
        .map(card => card.offsetLeft - offset)
        .map(p => Math.min(Math.max(p, 0), max));
      return [...new Set(positions)];
    }

    _scroll(dir) {
      this._collapse(false);

      const positions = this._snapPositions();
      const current = this.track.scrollLeft;
      const tolerance = 2;

      let target;
      if (dir > 0) {
        target = positions.find(p => p > current + tolerance);
        if (target === undefined) target = this._maxScroll();
      } else {
        target = [...positions].reverse().find(p => p < current - tolerance);
        if (target === undefined) target = 0;
      }

      this.track.scrollTo({ left: target, behavior: 'smooth' });
    }

    _updateButtons() {
      const current = this.track.scrollLeft;
      const max = this._maxScroll();
      const atStart = current <= 2;
      const atEnd = current >= max - 2;

      this.prevBtns.forEach(btn => {
        btn.disabled = atStart;
        btn.classList.toggle('cardSlider__navBtn--disabled', atStart);
      });
      this.nextBtns.forEach(btn => {
        btn.disabled = atEnd;
        btn.classList.toggle('cardSlider__navBtn--disabled', atEnd);
      });
    }

    _expand(card) {
      if (this.expandedCard && this.expandedCard !== card) {
        this.expandedCard.classList.remove('cardSlider__card--expanded', 'cardSlider__card--collapsing');
      }

      this.expandedCard = card;
      this._scrollBeforeExpand = this.track.scrollLeft;

      card.classList.add('cardSlider__card--expanded');

      // Scroll erst NACH der flex-basis Transition, sonst cancelt
      // die Layoutaenderung den laufenden Smooth Scroll
      if (window.innerWidth >= 750) {
        const doScroll = () => {
          const target = Math.min(
            Math.max(card.offsetLeft - this._snapOffset(), 0),
            this._maxScroll()
          );
          this.track.scrollTo({ left: target, behavior: 'smooth' });
        };
        let done = false;
        const once = () => {
          if (!done && this.expandedCard === card) { done = true; doScroll(); }
        };
        card.addEventListener('transitionend', once, { once: true });
        setTimeout(once, 500);
      }
    }

    _collapse(restoreScroll = true) {
      if (!this.expandedCard) return;

      const card = this.expandedCard;
      this.expandedCard = null;

      if (window.innerWidth >= 750) {
        card.classList.add('cardSlider__card--collapsing');
        if (restoreScroll) {
          this.track.scrollTo({ left: this._scrollBeforeExpand, behavior: 'smooth' });
        }
        card.addEventListener('transitionend', () => {
          card.classList.remove('cardSlider__card--collapsing');
        }, { once: true });
        // Fallback falls transitionend nicht feuert
        setTimeout(() => card.classList.remove('cardSlider__card--collapsing'), 600);
      }

      card.classList.remove('cardSlider__card--expanded');
    }
  }

  function init() {
    document.querySelectorAll('.cardSlider').forEach(el => new CardSlider(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();